import { useEffect } from "react";
import { contasController, ContasViewProps, mapDispatchToContasProps, mapStateToContasProps } from "../contas.controll";
import { Select as ViewList } from "../../../components/select";
import { ResumoContasPessoa } from "../../../data.types";
import { GridColDef } from "@mui/x-data-grid";
import { formatMoney } from "../../../services/utils";
import { Box, Typography } from "@mui/material";
import { connect } from "react-redux";
import { navigationToContaDetalheView } from "../contas.router";
import { ContasCadastro } from "./contas.cad";

const columns: GridColDef[] = [

    { field: 'key.nome', headerName: 'Nome', flex: 3, valueGetter: (value, row: ResumoContasPessoa) => row.key.nome },
    { field: 'value', headerName: 'Valor', flex: 1, renderCell: (prm) => formatMoney(prm.value) },
]

interface ContasResumoProps extends ContasViewProps {
    tipo: "pagar" | "receber"
}
function ContasResumo(props: ContasResumoProps) {
    const { tipo, contasState, contasActions } = props
    const { contas_resumo,contaResumoSelected,showAlert,msg,status,loadingRows,changeList,showCadModal } = contasState
    const { setShowAlert,readResumoContas,set,setShowCadModal,setShowMsg,handleNovaConta,setContaResumoSelected } = contasActions
    useEffect(() => {
        readResumoContas(tipo)
    }, [tipo])

    const handleAlterar = async (row: ResumoContasPessoa)=> {
        setContaResumoSelected(row);
        navigationToContaDetalheView();     
    }

     function Cadastro() {
         return ContasCadastro({
             ...props,
             handleCloseView: ()=>setShowCadModal(false),
         }).renderModal({
             handleClose: ()=>setShowCadModal(false),
             show: showCadModal,
             width: "sm",
             heigth: "auto",
         })
     }  

    const totalContas = () => {
        return contas_resumo.map(conta=>conta.value).reduce((a,b)=>a+b,0)
    }

    const getDataVencimento = (): string => {
        const data = new Date()
        data.setDate(data.getDate() + 30)
        return data.toISOString()
    }

    return (
        <ViewList
            displayWidth={window.innerWidth}
            title={`Total Contas ${formatMoney(totalContas())}`}
            row={contaResumoSelected}
            showAlert={showAlert}
            closeAlert={() => setShowAlert(false)}
            msg={msg}
            status={status}
            elevation={1}
            getRowId={(row:ResumoContasPessoa) => row.key._id}
            handleOnChange={handleAlterar}
            actionsOnkeyEnter={handleAlterar}
            showSearchContainer={true}
            fontSize={20}
            setTextSearch={() => { }}
            textSearch={""}
            fieldSearch={"key.nome"}
            columns={columns}
            rows={contas_resumo}
            loading={loadingRows}
            setRow={handleAlterar}
            changeList={changeList}
            buttonNew={{
                show: true,
                onClick: () => handleNovaConta({tipo:tipo,pessoa:{_id:"",nome:""},data_venc: getDataVencimento(),descricao:"",movimentacao:{_id:"",codigo:""},valor:0}),
            }}
            buttonRefresh={{
                show: true,
                onClick: () => readResumoContas(tipo)
            }}
            ListItemTextPrimary={(row: ResumoContasPessoa) =>
                <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                    <Typography component={"span"}>{row.key.nome}</Typography>
                    <Typography component={"span"}>{formatMoney(row.value)}</Typography>
                </Box>
            }
            ViewBeforeGridList={()=><Cadastro />}
        />
    )
}

export default connect(mapStateToContasProps, mapDispatchToContasProps)(ContasResumo);